export const SYNC_LABEL = 'Sync';
export const MASTER = 'master';
export const ATTENTION_MODAL_HEADING = 'Attention';
export const ATTENTION_MODAL_SUBMSG = 'not Synced';
